import React from 'react'
import ArrowIcon from '../arrow-icon/ArrowIcon'
import {
  insertBreaks,
  mapArrIndexed,
  sortByFootnote,
  flattenObj,
} from '../helpers'
import classnames from 'classnames'
import { withPrefix } from 'gatsby'
import * as R from 'ramda'

class Drawer extends React.Component {
  renderGalleryNotes(props, contentTotal) {
    const currentView = this.props.currentView
    const key = currentView + '-' + props.sectionId
    const rowClass = classnames('drawer__row', {
      'drawer__row--focused':
        R.has(key, this.props.currentFootnotes) &&
        this.props.currentFootnotes[key] === props.footNum,
      'drawer__row--hidden':
        R.has(key, this.props.currentFootnotes) &&
        this.props.currentFootnotes[key] !== props.footNum,
    })
    return (
      <React.Fragment key={props.footNum}>
        <div
          className={rowClass}
          id={currentView + '-' + props.sectionId + '-' + props.footNum}
        >
          <div
            className="drawer__num"
            onClick={e =>
              this.props.updateFootnote(
                e,
                props.sectionId,
                props.footNum,
                currentView
              )
            }
          >
            {props.footNum}
          </div>
          <div className="drawer__copy">
            <div className="drawer__image--referenced">
              {props.image && <img src={withPrefix(props.image)} alt="" />}
            </div>
            <div className="drawer__text">
              <div dangerouslySetInnerHTML={insertBreaks(props.copy)} />
            </div>
          </div>

          {contentTotal > 1 && this.renderShowAll(props.sectionId, currentView)}
        </div>
      </React.Fragment>
    )
  }
  renderColorNotes(props) {
    const currentView = this.props.currentView
    const id = props.id
    const key = currentView + '-' + props.sectionId
    const rowClass = classnames('drawer__row', id, 'js-' + id, {
      'drawer__row--hidden': R.has(key, this.props.currentFootnotes),
    })
    const image =
      currentView == 'translation'
        ? props.translationNotes
        : props.transcriptionNotes
    return (
      <React.Fragment>
        <div className={rowClass}>
          <div className="drawer__image--color">
            {image.image && (
              <img
                src={withPrefix(image.image)}
                alt={image.alt ? image.alt : ''}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderShowAll(sectionId, currentView) {
    return (
      <button
        className="drawer-show-all"
        onClick={() => this.props.showAllFootnotes(sectionId, currentView)}
        type="button"
      >
        <span className="drawer-show-all__arrow">
          <ArrowIcon />
        </span>
        <span> All Footnotes</span>
      </button>
    )
  }
  renderTranslatorNotes(props, contentTotal) {
    const currentView = this.props.currentView
    const key = currentView + '-' + props.sectionId
    const rowClass = classnames('drawer__row', {
      'drawer__row--focused':
        R.has(key, this.props.currentFootnotes) &&
        this.props.currentFootnotes[key] === props.footNum,
      'drawer__row--hidden':
        R.has(key, this.props.currentFootnotes) &&
        this.props.currentFootnotes[key] !== props.footNum,
    })
    return (
      <React.Fragment key={props.footNum}>
        <div
          className={rowClass}
          id={currentView + '-' + props.sectionId + '-' + props.footNum}
        >
          <div
            className="drawer__num"
            onClick={e =>
              this.props.updateFootnote(
                e,
                props.sectionId,
                props.footNum,
                currentView
              )
            }
          >
            {props.footNum}
          </div>
          <div className="drawer__copy">
            <div dangerouslySetInnerHTML={{ __html: props.note }} />
          </div>

          {contentTotal > 1 && this.renderShowAll(props.sectionId, currentView)}
        </div>
      </React.Fragment>
    )
  }
  renderNotes(props, contentTotal) {
    const type = props.type
    if (type === 'relatedArt') {
      return this.renderGalleryNotes(props, contentTotal)
    } else if (
      type === 'translatorNotes' &&
      this.props.currentView === 'translation'
    ) {
      return this.renderTranslatorNotes(props, contentTotal)
    }
  }
  getNoteTypes(props, contentTotal) {
    const allNotes = R.map(x => this.renderNotes(x, contentTotal), props)
    return allNotes
  }
  addType(type, sectionId, array) {
    if (array.length) {
      return array.map(x => {
        x.type = type
        x.sectionId = sectionId
        return x
      })
    } else {
      return []
    }
  }
  filterOutEmpty(array) {
    const reject = R.reject(x => {
      R.all(R.isEmpty, R.values(flattenObj(x)))
    }, array)
    if (R.all(R.isEmpty, R.values(flattenObj(reject)))) {
      return []
    } else {
      return reject
    }
  }
  render() {
    const sectionId = this.props.sectionId ? this.props.sectionId : ''
    //since we can't check for ids, colornotes that are populated should always have both a transcription and translation image, so we're checking for one
    const colorNotes = !R.isEmpty(
      this.props.colorNotes.transcriptionNotes.image
    )
      ? this.props.colorNotes
      : null
    if (colorNotes) {
      colorNotes.sectionId = sectionId
    }
    const newRelatedArt = this.addType(
      'relatedArt',
      sectionId,
      this.filterOutEmpty(this.props.relatedArt)
    )
    const newTranslatorNotes = this.addType(
      'translatorNotes',
      sectionId,
      this.filterOutEmpty(this.props.translatorNotes)
    )

    const newContent =
      this.props.currentView == 'translation'
        ? [...newTranslatorNotes, ...newRelatedArt]
        : [...newRelatedArt]

    const contentTotal = newContent.length
    const drawerClass = classnames('drawer js-drawer', {
      'drawer--focused': R.has(
        this.props.currentView + '-' + sectionId,
        this.props.currentFootnotes
      ),
    })
    return (
      <React.Fragment>
        <button
          aria-expanded="false"
          className="drawer__btn js-drawer__btn"
          onClick={e =>
            this.props.toggleDrawer(e, sectionId, this.props.currentView)
          }
          type="button"
        >
          <div className="drawer__show">
            <span className="visually-hidden">Show</span> Footnotes
          </div>
          <div className="drawer__hide">
            <span className="visually-hidden">Hide</span> Footnotes
          </div>

          <span className="drawer-x"> </span>
        </button>
        <div tabIndex="-1" className={drawerClass}>
          <div className="drawer__content">
            {this.getNoteTypes(newContent.sort(sortByFootnote), contentTotal)}
            {colorNotes && this.renderColorNotes(colorNotes)}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default Drawer
